export default __webpack_public_path__ + "static/media/portis.16b36bb5.svg";